import { LOGOUT_SUCCESS, USER_TX_SUCCESS } from '../actions'
import {
  ACTION_LOCATION_CHANGE,
  APP_LAST_VISITED_USER_TX_URL,
  REGEX_PATTERN_UUID,
  STORAGE_TYPE_LOCAL,
  USER_TX_DETAILS_PARENT_URI,
} from '../config'
import StorageProviderFactory from '../managers/storage_provider_factory'

const lastUserTransactionVisited = (store) => (next) => (action) => {
  if (typeof action === 'undefined') {
    return
  }
  // use this action as event to delete last visited user TX
  if (action.type === USER_TX_SUCCESS || action.type === LOGOUT_SUCCESS) {
    StorageProviderFactory.create(STORAGE_TYPE_LOCAL).removeItem(APP_LAST_VISITED_USER_TX_URL)
  }

  // listen to location updates
  if (action.type === ACTION_LOCATION_CHANGE) {
    const { pathname } = window.location

    if (store.getState().auth.isAuthenticated) {
      if (pathname !== '/' && !pathname.startsWith(USER_TX_DETAILS_PARENT_URI)) {
        StorageProviderFactory.create(STORAGE_TYPE_LOCAL).removeItem(APP_LAST_VISITED_USER_TX_URL)
      }
    } else {
      if (pathname.startsWith(USER_TX_DETAILS_PARENT_URI)) {
        const arr = pathname.split('/')
        if (arr.length === 3) {
          if (REGEX_PATTERN_UUID.test(arr[2])) {
            StorageProviderFactory.create(STORAGE_TYPE_LOCAL).setItem(APP_LAST_VISITED_USER_TX_URL, pathname)
          }
        }
      }
    }
  }

  if (typeof action.then !== 'function') {
    return next(action)
  }
}

export default lastUserTransactionVisited
